import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";

import API from "../../../../actions/api-helper";
import UI from "../../../../actions/ui-helper";

import AuditoriaProcedimentoValor from "./AuditoriaProcedimentoValor";

class AuditoriaProcedimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      versaoId: 0,
      procedimento: false
    }
    if (this.props.match.params.id) {
      this.state.entidadeId = this.props.match.params.id;
    }
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    UI.loader("show", "Carregando histórico...");
    API.get("/historico/Procedimento/" + this.state.entidadeId)
      .then(
        (json) => {
          if (json.data.length > 0) {
            let versaoId = json.data.length - 1;
            let versao = json.data[versaoId].instancia;
            versao.valorReceber = versao.valorReceber.toFixed(2);
            for (var i = 0; i < versao.valores.length; i++) {
              let valor = versao.valores[i].valorPagar;
              versao.valores[i].valorPagar = valor.toFixed(2);
            }
            this.setState({ versaoId: versaoId, historico: json.data, procedimento: versao });
          }
          else {
            UI.alert(false, "Este procedimento não teve auditoria.");
          }
          UI.loader("hide");
        })
      .catch(
        (json) => {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
  }

  handleChange(event) {
    let versaoId = parseInt(event.target.value);
    let versao = this.state.historico[versaoId].instancia;
    this.setState({ [event.target.name]: event.target.value, procedimento: versao });
  }

  componentDidUpdate() {
    UI.inputHelpers();
  }

  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    let styleSelecao = {
      border: "1px solid #777",
      borderWidth: "1px 1px 0px 1px",
      color: "rgb(0,0,150)",
      fontWeight: "700",
      background: "#ddd"
    }

    if (!this.state.procedimento) return false;
    let procedimento = this.state.procedimento;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6 text-right">
            <select
              style={styleSelecao}
              name="versaoId"
              className="form-control"
              value={this.state.versaoId}
              onChange={this.handleChange}
            >
              {this.state.historico.map((versao, i) => {
                return (
                  <option key={i} value={i}>Versão #{i + 1} - {versao.dataHora} - {versao.usuario.nome}</option>
                );
              })}
            </select>
          </div>
          <div className="col-md-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">AUDITORIA DO PROCEDIMENTO #{procedimento.id}</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/procedimento/cadastro/" + procedimento.id) }}
                      className="btn btn-info">
                      <i className="fa fa-edit"></i>&nbsp;Editar
                      </button>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Código</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="codigo"
                      type="text"
                      className="form-control"
                      value={procedimento.codigo}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Data de Vigência</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="dataVigencia"
                      className="form-control"
                      mask="99/99/9999"
                      value={procedimento.dataVigencia}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Valor Receber (R$)</label>
                    <input
                      style={styleContraste}
                      disabled
                      type="number"
                      step="any"
                      name="valorReceber"
                      value={procedimento.valorReceber}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Unidade</label>
                    <select
                      style={styleContraste}
                      disabled
                      name="unidade"
                      className="form-control"
                      value={procedimento.unidade}
                    >
                      <option value={1}>HORA</option>
                      <option value={2}>LANÇAMENTO</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label>TIpo</label>
                    <select
                      style={styleContraste}
                      disabled
                      name="tipo"
                      className="form-control"
                      value={procedimento.tipo}
                    >
                      <option value={1}>ATENDIMENTO</option>
                      <option value={2}>ATIVIDADE / REUNIÃO</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Descrição</label>
                    <textarea
                      style={styleContraste}
                      disabled
                      rows="6"
                      placeholder="NÃO INFORMADO"
                      name="descricao"
                      className="form-control"
                      value={procedimento.descricao}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-check form-check-info">
                      <label className="form-check-label">
                        <input
                          name="grupoPaciente"
                          type="checkbox"
                          className="form-check-input"
                          checked={procedimento.grupoPaciente}
                        />
                        Grupo de Pacientes
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-check form-check-danger">
                      <label className="form-check-label">
                        <input
                          name="inativo"
                          type="checkbox"
                          className="form-check-input"
                          checked={procedimento.inativo}
                        />
                        Inativo
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AuditoriaProcedimentoValor
            valores={procedimento.valores}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(AuditoriaProcedimento);
